import {Picture} from 'mw/api/Metadata';

export class PictureMapper {
  public static pictureFromJson(json: any): Picture {
    const metadata = json.metadata || {type: '', format: '', width: 0, height: 0};
    return new Picture(json.purpose, json.cdnUrl, metadata.format, metadata.width, metadata.height);
  }
}
